export default __webpack_public_path__ + "static/media/lifeinwild.9f6ecc33.png";